import React from "react";
import { useTranslate } from "react-polyglot";
import { makeStyles } from "@material-ui/core";
import { Route, Switch, useHistory } from "react-router-dom";
import Box from "@material-ui/core/Box";
import { IS_APP_BEHAPPY, IS_APP_STUDYLESS } from "../../constants.js";
import Learn from "./Learning/Learn.jsx";
import CourseStartPage from "./Course/CourseStartPage.jsx";
import Dictionary from "./Dictionary/Dictionary.jsx";
import Events from "./Events/Events.jsx";
import News from "./News/News.jsx";
import useDesktopWidthMatch from "../../hooks/useDesktopWidthMatch.js";
import CourseProvider from "../../Providers/Data/CourseProvider.jsx";
import DictionaryProvider from "../../Providers/Data/DictionaryProvider.jsx";
import Profile from "../Profile/Profile.jsx";
import MissionsAndShopping from "../Missions/MissionsAndShopping.jsx";
import ProductCatalogProvider from "../../Providers/Data/ProductCatalogProvider.jsx";
import Leaderboard from "../Leaderboard/Leaderboard.jsx";
import MissionsProvider from "../../Providers/Data/MissionsProvider.jsx";
import FlexboxVertical from "../../SharedComponents/FlexboxVertical.jsx";
import ProtectedRoute from "../../Providers/Data/ProtectedRoute.jsx";
import { useBaseData } from "../../Providers/Data/BaseDataProvider.jsx";
import Homeworks from "./Homeworks/Homeworks.jsx";
import HomeworksProvider from "../../Providers/Data/HomeworksProvider.jsx";
import ToDoHomework from "./Homeworks/ToDoHomework.jsx";
import Orders from "../Orders/Orders.jsx";
import EventsStudyless from "./Events/EventsStudyless.jsx";
import Chat from "./Chat/Chat.jsx";
import BranchDeckLayout from "./Course/BranchDeckLayout.jsx";

const useStyles = makeStyles({
  tabsMainBox: {
    width: "100%",
    borderRadius: 22,
    backgroundColor: "#F1F2F2",
    flexGrow: 1,
  },
  fixedWidth: {
    width: ({ isDesktop }) => (isDesktop ? 1300 : 847),
    margin: "0 auto",
  },
  //TODO временный стиль только для миссий. Убрать после редизайна всего
  mainBox: {
    // backgroundColor: "#F1F2F2",
    minHeight: "calc(100vh - 96px)",
    height: "auto",
  },
});

/**
 * @returns {*}
 * @constructor
 */
const HomeTabs = () => {
  const isDesktop = useDesktopWidthMatch();
  const classes = useStyles({ isDesktop: isDesktop });
  const t = useTranslate();
  //TODO временный стиль только для миссий. Убрать после редизайна всего
  const history = useHistory();
  const location = history.location.pathname;
  //
  const { userInfo } = useBaseData();

  return (
    <FlexboxVertical className={classes.tabsMainBox}>
      <Box className={location.startsWith("/missions") ? classes.mainBox : ""}>
        <Box className={classes.fixedWidth}>
          <Switch>
            <Route exact path="/">
              <CourseProvider>
                <CourseStartPage />
              </CourseProvider>
            </Route>
            {/* Разделы и уроки доступны в режиме просмотра даже деактивированным пользователям */}
            <Route path={["/branches", "/decks"]}>
              <CourseProvider>
                <BranchDeckLayout />
              </CourseProvider>
            </Route>
            <ProtectedRoute
              path={["/learn/:deckId", "/learn/:deckId/:wordId"]}
              condition={userInfo.isActive || userInfo.isDemoMode}
              forbiddenRedirect="/"
            >
              <CourseProvider>
                <Learn />
              </CourseProvider>
            </ProtectedRoute>
            <ProtectedRoute
              exact
              path="/dictionary"
              condition={userInfo.subject.dictionaryEnabled && (userInfo.isActive || userInfo.isDemoMode)}
              forbiddenRedirect="/"
            >
              <DictionaryProvider>
                <Dictionary />
              </DictionaryProvider>
            </ProtectedRoute>
            <ProtectedRoute
              path="/homeworks"
              condition={userInfo.isActive || userInfo.isDemoMode}
              forbiddenRedirect="/"
            >
              <HomeworksProvider>
                <Route exact path="/homeworks">
                  <Homeworks />
                </Route>
                <Route path={["/homeworks/todo", "/homeworks/finished"]}>
                  <ToDoHomework />
                </Route>
              </HomeworksProvider>
            </ProtectedRoute>
            <ProtectedRoute
              path="/events"
              condition={
                (userInfo.isActive || userInfo.isDemoMode) && userInfo?.subject?.eventSettings?.isEventsListAvailable
              }
              forbiddenRedirect="/"
            >
              {IS_APP_STUDYLESS ? <EventsStudyless /> : <Events />}
            </ProtectedRoute>
            <ProtectedRoute path="/news" condition={userInfo.isActive || userInfo.isDemoMode} forbiddenRedirect="/">
              <News />
            </ProtectedRoute>
            <Route path="/profile">
              <Profile />
            </Route>
            <Route path="/orders">
              <Orders />
            </Route>
            <ProtectedRoute
              path="/missions"
              condition={userInfo.subject.missionsEnabled && (userInfo.isActive || userInfo.isDemoMode)}
              forbiddenRedirect="/"
            >
              <MissionsProvider>
                <ProductCatalogProvider>
                  <MissionsAndShopping />
                </ProductCatalogProvider>
              </MissionsProvider>
            </ProtectedRoute>
            <ProtectedRoute path="/chat" condition={userInfo.isActive || userInfo.isDemoMode} forbiddenRedirect="/">
              <Chat />
            </ProtectedRoute>
            <ProtectedRoute path="/leaderboard" condition={!IS_APP_STUDYLESS && !IS_APP_BEHAPPY} forbiddenRedirect="/">
              <Leaderboard />
            </ProtectedRoute>
          </Switch>
        </Box>
      </Box>
    </FlexboxVertical>
  );
};

export default HomeTabs;
